import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { LinkLegislacaoService } from '../../../services/link-legislacao.service';

@Component({
  selector: 'app-link-legislacao-list',
  templateUrl: './link-legislacao-list.component.html',
  styleUrls: ['./link-legislacao-list.component.scss']
})
export class LinkLegislacaoListComponent extends BaseListComponent<any> implements OnInit {

  list: any[];

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: LinkLegislacaoService,
  ) {
    super();
  }

  ngOnInit() {
    this.loading();
    this.initLoadDataTable();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.list = res;
        this.loaded();
      })
    );
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}